module.exports = __webpack_public_path__ + "img/bg_w.511641e3.jpeg";